import { ContextService } from '../../../services/context_service';
import { DatenverwaltungBereiche } from './DatenverwaltungBereiche';
import { DatenverwaltungGewerke } from './DatenverwaltungGewerke';
import { DatenverwaltungNace } from './DatenverwaltungNace';
import { DatenverwaltungGewerkegruppen } from './DatenverwaltungGewerkegruppen';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { Routing } from '../../../helpers/Routing';
import { RoutingIDs } from '../../../helpers/RoutingAdminIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

interface DatenverwaltungTabBereichsstrukturProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

interface DatenverwaltungTabBereichsstrukturState {
    tabIndex: number;
}

export class DatenverwaltungTabBereichsstruktur extends
    React.Component<DatenverwaltungTabBereichsstrukturProps, DatenverwaltungTabBereichsstrukturState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: null
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private disabled: string[] = [];
    private prefix: string = 'admin.tab.datenverwaltung.bereichsstruktur';
    private rechte: any = {};
    private tabName: string = RoutingIDs.TABS_DATENVERWALTUNG_BEREICHSSTRUKTUR;
    private tabIndex: string = `${this.tabName}Index`;
    private tabRoutings: any[] = [
        { path: RoutingIDs.ROUTE_BEREICHSSTRUKTUR_BEREICHE },
        { path: RoutingIDs.ROUTE_BEREICHSSTRUKTUR_GEWERKE_DEFINITION },
        { path: RoutingIDs.ROUTE_BEREICHSSTRUKTUR_WZ_DEFINITION },
        { path: RoutingIDs.ROUTE_BEREICHSSTRUKTUR_GEWERKE_GRUPPE }
    ];
    private tabs: string[] = ['bereiche', 'gewerke', 'wz', 'gewerkegruppen']; // Reitereihenfolge beachten

    componentDidMount(): void {
        (new Routing(this)).init((rechte: any, tabIndex: number) => {
            this.rechte = rechte || {};
            this.setTabIndex(tabIndex, this.tabRoutings[tabIndex]);
        });
    }

    componentDidUpdate(prevProps: any): void {
        if (JSON.stringify(this.props.routing) !== JSON.stringify(prevProps.routing)) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        if (typeof (routing.path || {})[this.tabName] === 'undefined') {
            return;
        }
        // this.setTabIndex(routing.path[this.tabName], routing, () => {
        //     if (routing.path.terminateOn === this.tabName) {
        //         this.props.onRoutingChange({});
        //     }
        // });
        if (this.state.tabIndex === routing.path[this.tabName]) {
            if (routing.path.terminateOn === this.tabName) {
                this.props.onRoutingChange({});
            }
        } else {
            this.setTabIndex(routing.path[this.tabName], routing);
        }
    }

    render(): JSX.Element {
        if (this.state.tabIndex === null) {
            return null;
        }

        return (
            <Tabs
                className='tabs-admin-datenverwaltung'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, this.tabRoutings[tabIndex])}
            >
                <TabList>
                    <Tab disabled={!this.rechte.bereiche}>Bereiche</Tab>
                    <Tab disabled={!this.rechte.gewerke}>Gewerke (Definition)</Tab>
                    <Tab disabled={!this.rechte.wz}>WZ (Definition)</Tab>
                    <Tab disabled={!this.rechte.gewerkegruppen}>Gewerkegruppen</Tab>
                </TabList>
                <TabPanel>
                    {this.rechte.bereiche &&
                        <DatenverwaltungBereiche />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.gewerke &&
                        <DatenverwaltungGewerke />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.wz &&
                        <DatenverwaltungNace data={this.props.data} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.gewerkegruppen &&
                        <DatenverwaltungGewerkegruppen data={this.props.data} />
                    }
                </TabPanel>
            </Tabs>
        );
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(this.tabIndex, tabIndex);

                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        }
    }
}
